import {
  createRootRouteWithContext,
  Outlet,
  useLocation,
} from "@tanstack/react-router";
import * as React from "react";
import { Container } from "react-bootstrap";
import ErrorComponent from "@/components/ErrorComponent";
import Navbar from "@/components/Navbar";
import "@/css/root.scss";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import Footer from "@/components/Footer";
import NotFound from "@/components/NotFound";
import type { AuthContext } from "@/contexts/AuthContext";
import { useRaygun } from "@/hooks/useRaygun";

interface RouterContext {
  auth: AuthContext;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  errorComponent: ({ error }) => <ErrorComponent error={error} />,
  notFoundComponent: () => <NotFound />,
});

function RootComponent() {
  const location = useLocation();
  const { trackPageView } = useRaygun();

  React.useEffect(() => {
    void trackPageView(location.pathname);
  }, [location.pathname, trackPageView]);

  return (
    <React.Fragment>
      <Navbar />
      <main>
        <Container fluid>
          <Outlet />
          <TanStackRouterDevtools />
        </Container>
      </main>
      <Footer />
    </React.Fragment>
  );
}
